import { Component } from '@angular/core';

@Component({
  selector: 'app-search-snacks-home',
  templateUrl: './search-snacks-home.component.html',
  styleUrl: './search-snacks-home.component.scss'
})
export class SearchSnacksHomeComponent {

}
